module.exports = __webpack_public_path__ + "img/pr-17.48b31d51.png";